import { render, staticRenderFns } from "./AdminUsersHeader.module.vue?vue&type=template&id=cded465a&scoped=true&"
import script from "./AdminUsersHeader.module.vue?vue&type=script&lang=js&"
export * from "./AdminUsersHeader.module.vue?vue&type=script&lang=js&"
import style0 from "./AdminUsersHeader.module.vue?vue&type=style&index=0&id=cded465a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cded465a",
  null
  
)

export default component.exports